import { Link } from "react-router-dom";
import Icon from "./Icon";
import { company } from "../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__col footer__col--brand">
          <div className="footer__brand">
            <div className="footer__logo-badge">
              <img
                src="/logo-full.png"
                alt={`${company.brand} — ${company.legalName}`}
                className="footer__logo-img"
              />
            </div>
          </div>
          <p className="footer__desc">
            Strategic freight forwarding, customs clearance, warehousing, and supply
            chain solutions connecting businesses across nations.
          </p>
          <p className="footer__slogan">&ldquo;{company.slogan}&rdquo;</p>
        </div>

        <div className="footer__col">
          <h3>Navigate</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/industries">Industries</Link></li>
            <li><Link to="/team">Team</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h3>Services</h3>
          <ul>
            <li><Link to="/services">Freight Forwarding</Link></li>
            <li><Link to="/services">Customs Clearance</Link></li>
            <li><Link to="/services">Warehousing</Link></li>
            <li><Link to="/services">Project Logistics</Link></li>
            <li><Link to="/services">Supply Chain Solutions</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h3>Contact</h3>
          <ul className="footer__contact">
            <li>
              <Icon name="phoneCall" size={16} />
              <a href={`tel:${company.phone.replace(/[^+\d]/g, "")}`}>{company.phone}</a>
            </li>
            <li>
              <Icon name="phoneCall" size={16} />
              <a href={`tel:${company.mobile.replace(/[^+\d]/g, "")}`}>{company.mobile}</a>
            </li>
            <li>
              <Icon name="mail" size={16} />
              <a href={`mailto:${company.emails.partnership}`}>{company.emails.partnership}</a>
            </li>
            <li>
              <Icon name="mail" size={16} />
              <a href={`mailto:${company.emails.customerService}`}>{company.emails.customerService}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <span>&copy; {year} {company.legalName}. All rights reserved.</span>
          <span>{company.domain.replace("https://www.", "www.")}</span>
        </div>
      </div>
    </footer>
  );
}
